// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/v2/tenant_failover.proto (package infinigence.infini.agentplatform.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/v2/tenant_failover.proto.
 */
export const file_agentplatform_v2_tenant_failover: GenFile = /*@__PURE__*/
  fileDesc("CiZhZ2VudHBsYXRmb3JtL3YyL3RlbmFudF9mYWlsb3Zlci5wcm90bxIjaW5maW5pZ2VuY2UuaW5maW5pLmFnZW50cGxhdGZvcm0udjIi0QEKDlRlbmFudEZhaWxvdmVyEgoKAmlkGAEgASgJEhwKCXRlbmFudF9pZBgCIAEoCVIJdGVuYW50X2lkEiQKDWJhY2t1cF9tb2RlbHMYAyADKAlSDWJhY2t1cF9tb2RlbHMSDwoHZW5hYmxlZBgEIAEoCBIeCgpjcmVhdGVkX2F0GAUgASgDUgpjcmVhdGVkX2F0Eh4KCnVwZGF0ZWRfYXQYBiABKANSCnVwZGF0ZWRfYXQSHgoKZGVsZXRlZF9hdBgHIAEoA1IKZGVsZXRlZF9hdEJJWkdnaXRsYWIuaW5maW5pLWFpLmNvbS9taXphci9pbmZpbmlhaS1hZ2VudGljLWluZnJhL2NvbW1vbi9ncnBjYXBpcy92Mjt2MmIGcHJvdG8z");

/**
 * TenantFailover 租户级模型 failover 备用池 / Tenant-level model failover pool
 *
 * @generated from message infinigence.infini.agentplatform.v2.TenantFailover
 */
export type TenantFailover = Message<"infinigence.infini.agentplatform.v2.TenantFailover"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 所属租户 ID / Tenant ID
   * @gotags: json:"tenant_id,omitempty"
   *
   * @generated from field: string tenant_id = 2 [json_name = "tenant_id"];
   */
  tenantId: string;

  /**
   * 备用模型池（有序，模型名称，从左到右依次降级切换）/ Backup model list (ordered, failover left-to-right)
   * @gotags: json:"backup_models,omitempty"
   *
   * @generated from field: repeated string backup_models = 3 [json_name = "backup_models"];
   */
  backupModels: string[];

  /**
   * 备用池是否启用 / Whether the failover pool is enabled
   * @gotags: json:"enabled,omitempty"
   *
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;

  /**
   * 创建时间（unix nano）/ Created at (unix nano)
   * @gotags: json:"created_at,omitempty"
   *
   * @generated from field: int64 created_at = 5 [json_name = "created_at"];
   */
  createdAt: bigint;

  /**
   * 更新时间（unix nano）/ Updated at (unix nano)
   * @gotags: json:"updated_at,omitempty"
   *
   * @generated from field: int64 updated_at = 6 [json_name = "updated_at"];
   */
  updatedAt: bigint;

  /**
   * 删除时间（unix nano，软删）/ Deleted at (unix nano, soft delete)
   * @gotags: json:"deleted_at,omitempty"
   *
   * @generated from field: int64 deleted_at = 7 [json_name = "deleted_at"];
   */
  deletedAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.v2.TenantFailover.
 * Use `create(TenantFailoverSchema)` to create a new message.
 */
export const TenantFailoverSchema: GenMessage<TenantFailover> = /*@__PURE__*/
  messageDesc(file_agentplatform_v2_tenant_failover, 0);

